<template>
    <div>
        <b-row>
            <b-col md="12" class="my-1">
                <h3 class="text-themecolor">{{$t('klanten.overdefmmoduleklant')}}</h3>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="4" xlg="3" md="4">
                <div class="card">
                    <div class="card-body">
                        <div v-if="company.id">
                            <center class="m-t-30">
                                <h4 class="card-title m-t-10">{{company.name}}</h4>
                                <h6 class="card-subtitle">{{company.domainName}}</h6>
                            </center>
                            <hr> 
                            <small class="text-muted">{{$t('klanten.serienummer')}}</small>
                            <h6>{{company.license}}</h6>
                            <h6></h6>
                            <small class="text-muted"> {{$t('fmbeheer.primarelatienummer')}}</small>
                            <h6>{{company.primaRelatienummer ? company.primaRelatienummer : '-'}}</h6>
                            <h6></h6>
                            <small class="text-muted"> {{$t('fmbeheer.huidigerelease')}}</small>
                            <h6>{{company.currentRelease ? company.currentRelease : '-'}}</h6>
                            <h6></h6>
                            <small class="text-muted"> {{$t('fmbeheer.vorigerelease')}}</small>
                            <h6>{{company.previousRelease ? company.previousRelease : '-'}}</h6>
                        </div>
                        <div v-else>
                            <content-placeholders>
                                <content-placeholders-heading />
                                <content-placeholders-text :lines="2" />
                                <content-placeholders-heading />
                                <content-placeholders-text :lines="2" />
                            </content-placeholders>
                        </div>
                    </div>
                </div>
            </b-col>
            
            <b-col lg="8" xlg="9" md="8">
                <div class="card">
                    <ul class="nav nav-tabs profile-tab" role="tablist">
                        <li class="nav-item">
                            <router-link :to="{ name: 'customers:detail:administrations' }" class="nav-link" data-toggle="tab" role="tab" aria-expanded="false">
                                 {{$t('fmbeheer.administraties')}}
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{ name: 'customers:detail:price-agreements' }" class="nav-link" data-toggle="tab" role="tab" aria-expanded="false">
                                {{$t('priceagreements.prijsafspraken')}}
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{ name: 'customers:detail:invoices' }" class="nav-link" data-toggle="tab" role="tab" aria-expanded="false">
                                {{$t('klanten.facturatie')}}
                            </router-link>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane active" role="tabpanel">
                            <!-- Tabs, lazy loading -->
                            <router-view />
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <b-button @click="goTo('index')" variant="secondary">{{$t('buttons.terugnaaroverzicht')}}</b-button>
            </b-col>
        </b-row>
    </div>
</template>
<script>
//Import store
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'customers-detail',
    computed: {
        ...mapGetters('fm',['company']),
    },
    methods: {
        ...mapActions('fm',['find']),
        goTo(name) {
            var vm = this;
            vm.$router.push({ name: `customers:${name}` });
        }
    },
    created() {
        let vm = this;
        
        vm.find({
            resource: 'companies',
            id: vm.$route.params.companyId
        });
    }
}
</script>